var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.$store.state.is_loading)?_c('Link',{key:_vm.link,staticClass:"post-newsletter",attrs:{"post_link":_vm.link,"id":_vm.id}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.text)}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }